'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var forEachClassName = function forEachClassName(classNames, cb) {
  classNames.trim().split(/\s+/).forEach(function (className) {
    cb(className);
  });
};

/**
 * Passes the child component through directly, while toggling
 * the body class according to the bodyClassName prop
 */
exports.default = _react2.default.createClass({
  displayName: 'ComponentWithBodyClass',

  propTypes: {
    bodyClassName: _react.PropTypes.string.isRequired,
    bodyElement: _react.PropTypes.object.isRequired,
    children: _react.PropTypes.node
  },

  getDefaultProps: function getDefaultProps() {
    return {
      bodyElement: document.body
    };
  },
  componentWillMount: function componentWillMount() {
    this.toggleBodyClass(true, this.props.bodyClassName);
  },
  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
    var bodyClassName = _ref.bodyClassName;

    if (bodyClassName !== this.props.bodyClassName) {
      this.toggleBodyClass(false, this.props.bodyClassName);
      this.toggleBodyClass(true, bodyClassName);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.toggleBodyClass(false, this.props.bodyClassName);
  },
  toggleBodyClass: function toggleBodyClass(isMounting, bodyClassName) {
    var bodyElement = this.props.bodyElement;

    if (bodyClassName && bodyElement) {
      var func = isMounting ? 'add' : 'remove';
      forEachClassName(bodyClassName, function (className) {
        bodyElement.classList[func](className);
      });
    }
  },
  render: function render() {
    return _react.Children.only(this.props.children);
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/utils/ComponentWithBodyClass.js
// module id = 145
// module chunks = 0